import * as THREE from 'three'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js'
import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js'

let uMouse = new THREE.Vector2(0, 0)
const fov = 50

function getVideoDimensionsOf(videoSelector) {
  return new Promise((resolve) => {
    // create the video element
    const video = document.querySelector(videoSelector)

    // place a listener on it
    video.addEventListener(
      'loadedmetadata',
      function () {
        // retrieve dimensions
        const height = this.videoHeight
        const width = this.videoWidth

        // send back result
        resolve({ height, width })
      },
      false
    )
  })
}

export const init = async (element, container) => {
  let elem = document.querySelector(element)
  let texture
  let isVideo = false
  if (element.includes('video')) {
    const videoDimension = await getVideoDimensionsOf(element)
    texture = new THREE.VideoTexture(elem)
    texture.videoHeight = videoDimension.height
    texture.videoWidth = videoDimension.width
    isVideo = true
  } else {
    texture = await new THREE.TextureLoader().loadAsync(elem.src)
    isVideo = false
  }

  texture.needsUpdate = true

  let camera = new THREE.PerspectiveCamera(
    fov,
    window.innerWidth / window.innerHeight,
    0.01,
    10
  )
  camera.position.z = 10

  let scene = new THREE.Scene()

  scene.background = texture

  let renderer = new THREE.WebGLRenderer({ antialias: true })
  renderer.setSize(window.innerWidth, window.innerHeight)
  renderer.outputColorSpace = THREE.SRGBColorSpace
  document.querySelector(container).appendChild(renderer.domElement)

  // post processing
  let composer = new EffectComposer(renderer)
  let renderPass = new RenderPass(scene, camera)
  composer.addPass(renderPass)

  var myEffect = {
    uniforms: {
      tDiffuse: { value: null },
      resolution: {
        value: new THREE.Vector2(1, window.innerHeight / window.innerWidth),
      },
      uMouse: { value: new THREE.Vector2(-10, -10) },
      uVelo: { value: 0 },
    },
    vertexShader: `varying vec2 vUv;void main() {vUv = uv;gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0 );}`,
    fragmentShader: `uniform float time;
    uniform sampler2D tDiffuse;
    uniform vec2 resolution;
    varying vec2 vUv;
    uniform vec2 uMouse;
    float circle(vec2 uv, vec2 disc_center, float disc_radius, float border_size) {
      uv -= disc_center;
      uv*=resolution;
      float dist = sqrt(dot(uv, uv));
      return smoothstep(disc_radius+border_size, disc_radius-border_size, dist);
    }
    void main()  {
        vec2 newUV = vUv;
        float c = circle(vUv, uMouse, 0.0, 0.2);
        float r = texture2D(tDiffuse, newUV.xy += c * (0.1 * .1)).x;
        float g = texture2D(tDiffuse, newUV.xy += c * (0.1 * .125)).y;
        float b = texture2D(tDiffuse, newUV.xy += c * (0.1 * .15)).z;
        vec4 color = vec4(r, g, b, 1.);

        gl_FragColor = color;
    }`,
  }

  let customPass = new ShaderPass(myEffect)
  customPass.renderToScreen = true
  composer.addPass(customPass)

  const setBackground = (
    scene,
    backgroundImageWidth,
    backgroundImageHeight
  ) => {
    var windowSize = function (withScrollBar) {
      var wid = 0
      var hei = 0
      if (typeof window.innerWidth != 'undefined') {
        wid = window.innerWidth
        hei = window.innerHeight
      } else {
        if (document.documentElement.clientWidth == 0) {
          wid = document.body.clientWidth
          hei = document.body.clientHeight
        } else {
          wid = document.documentElement.clientWidth
          hei = document.documentElement.clientHeight
        }
      }
      return {
        width: wid - (withScrollBar ? wid - document.body.offsetWidth + 1 : 0),
        height: hei,
      }
    }

    if (scene.background) {
      var size = windowSize(true)
      var factor =
        backgroundImageWidth /
        backgroundImageHeight /
        (size.width / size.height)

      scene.background.offset.x = factor > 1 ? (1 - 1 / factor) / 2 : 0
      scene.background.offset.y = factor > 1 ? 0 : (1 - factor) / 2

      scene.background.repeat.x = factor > 1 ? 1 / factor : 1
      scene.background.repeat.y = factor > 1 ? 1 : factor
    }
  }

  const animate = () => {
    if (scene?.background) {
      if (isVideo) {
        setBackground(scene, texture.videoWidth, texture.videoHeight)
      } else {
        setBackground(scene, texture.image.width, texture.image.height)
      }
    }
    customPass.uniforms.uMouse.value = uMouse
    requestAnimationFrame(animate)
    composer.render()
  }
  if (isVideo) {
    setBackground(scene, texture.videoHeight, texture.videoWidth)
  } else {
    setBackground(scene, texture.image.width, texture.image.height)
  }

  animate()

  function dispose() {
    console.log('dispose renderer!')
    renderer.dispose()

    scene.traverse((object) => {
      if (!object.isMesh) return

      console.log('dispose geometry!')
      object.geometry.dispose()

      if (object.material.isMaterial) {
        cleanMaterial(object.material)
      } else {
        // an array of materials
        for (const material of object.material) cleanMaterial(material)
      }
    })

    const cleanMaterial = (material) => {
      console.log('dispose material!')
      material.dispose()

      // dispose textures
      for (const key of Object.keys(material)) {
        const value = material[key]
        if (value && typeof value === 'object' && 'minFilter' in value) {
          console.log('dispose texture!')
          value.dispose()
        }
      }
    }
    document.removeEventListener('mousemove', (e) => {
      // mousemove / touchmove
      uMouse.x = e.clientX / window.innerWidth
      uMouse.y = 1 - e.clientY / window.innerHeight
    })
    scene = null
  }

  return {
    dispose,
  }
}

document.addEventListener('mousemove', (e) => {
  // mousemove / touchmove
  uMouse.x = e.clientX / window.innerWidth
  uMouse.y = 1 - e.clientY / window.innerHeight
})
